// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"e28ab903","225":"01dee999","760":"40c63cc4","774":"f1364151","787":"8e29e0ab","854":"b8d480ad","883":"7ecdf537"}[chunkId] + ".chunk.js";
};